module.exports = __webpack_public_path__ + "img/hohlschnitt_lichtblau_ral5012.a7f4a3e7.jpg";